module.exports = __webpack_public_path__ + "img/sanel_logo.bc234e3b.png";